
<p [innerHtml]="terms">
</p>